import Choices from "choices.js"
import Toastify from "toastify-js"
import "toastify-js/src/toastify.css"
import Swal from "sweetalert2"
import * as util from "./util"
import * as utillogin from "./utillogin"

/* To locally debug this script via Webflow the best option I've found is to
add two scripts in Webflow:
<script src="http://localhost:3000/????.bundle.js"></script>
<script src="angry-boyd-1669aa.netlify.app/????.bundle.js" crossorigin="anonymous"></script>
The below check ensures that if localhost loads successfully the second
(production) script won't run.
Initially I tried to add the script dynamically in Webflow but that didn't
work - I needed it to run immediately but it wouldn't. */
if (typeof SharesyWebflow === "undefined") {
  util.initSentry()

  window.amplitudeOnLoad = function (instance) {
    util.amplitudeInit(instance, "Dashboard Calendar Sync Viewed")
  }

  // Wrap everything with Revealing Module Pattern
  window.SharesyWebflow = (function () {
    var searchParams = util.getSearchParams()
    var calendarSyncData
    var organisationChoices

    async function initChecks() {
      let isAdmin = await utillogin.getClerkUserIsAdmin()
      if (isAdmin) {
        utillogin.displayAdminNavItems()
      }

      if (searchParams.has("code") && searchParams.has("state")) {
        // If the code query param is present, it means the user has just
        // connected a calendar account via Cronofy, so we should show the
        // available calendars for the user to choose from.
        let token = await utillogin.getClerkToken()
        calendarSyncData = await fetch(
          `${util.API_GATEWAY}/cronofy-auth-token?code=${searchParams.get(
            "code"
          )}&token=${token}`,
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          }
        )
          .then((response) => response.json())
          .catch((error) => {
            util.logToSentry(error)
            util.logAmplitudeEvent("Unknown Error Retrieving Calendar Data")
          })
        if (calendarSyncData.calendars.length === 0) {
          await Swal.fire({
            icon: "error",
            text: "There was a problem retrieving your calendars. Please try to sync again, ensuring you agree to calendar permissions.",
            confirmButtonText: "Refresh",
            confirmButtonColor: "#d31818",
            customClass: {
              popup: "swal-custom-popup",
              title: "swal-custom-title",
              confirmButton: "swal-custom-button",
            },
            allowOutsideClick: false,
          })
          postSyncCleanup()
          util.logAmplitudeEvent("No Calendars Found After Sync")
          window.location.reload()
          return
        }
        let radio = document.getElementById("calendar-sync-radio")
        calendarSyncData.calendars.map((cal) => {
          let newRadio = radio.cloneNode(true)
          newRadio.id = cal.calendar_id
          newRadio.querySelector("input").value = cal.calendar_id
          newRadio.querySelector("span").innerText = cal.calendar_name
          newRadio.querySelector("input").required = true
          document.getElementById("calendar-radios").appendChild(newRadio)
        })
        // delete the template radio
        radio.remove()
        document.getElementById("modal-container").style.display = "flex"
        document.getElementById("choose-calendar-modal").style.display = "flex"
        util.logAmplitudeEvent("Open Choose Calendar Modal")
      }

      if (isAdmin) {
        initOrganisations()
      } else {
        initSpaces(null)
      }
    }

    async function initOrganisations() {
      let token = await utillogin.getClerkToken()
      let organisationData = await fetch(
        `${util.API_GATEWAY}/get-organisations-token?token=${token}`,
        {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        }
      )
        .then((response) => response.json())
        .catch((error) => {
          util.logToSentry(error)
          util.logAmplitudeEvent("Unknown Error Retrieving Organisations")
        })
      const organisationSelect = document.getElementById("select-organisation")
      organisationChoices = new Choices(organisationSelect, {
        itemSelectText: "",
        allowHTML: false,
        searchResultLimit: 10,
        choices: organisationData.map(function (d) {
          return {
            value: d.id,
            label: d.name,
          }
        }),
      })
      document.getElementById("organisation-section").classList.remove("hide")
      document.getElementById("spaces-to-sync-section").classList.add("hide")
      organisationSelect.addEventListener(
        "change",
        async function (event) {
          initSpaces(event.target.value)
          document
            .getElementById("spaces-to-sync-section")
            .classList.remove("hide")
          util.updateUrlParam("organisation", event.target.value, false, false)
          util.addUrlParamToLink(
            document.getElementById("top-nav-calendar"),
            "organisation",
            event.target.value
          )
        },
        false
      )
      if (searchParams.has("organisation")) {
        setOrganisation(parseInt(searchParams.get("organisation")))
      } else {
        organisationSelect.click()
      }
    }

    function setOrganisation(organisationId) {
      organisationChoices.setChoiceByValue(organisationId)
      initSpaces(organisationId)
      util.addUrlParamToLink(
        document.getElementById("top-nav-calendar"),
        "organisation",
        organisationId
      )
    }

    async function initSpaces(organisationId) {
      let token = await utillogin.getClerkToken()
      let endpoint = `${util.API_GATEWAY}/cronofy-synced-spaces?token=${token}`
      if (organisationId) {
        endpoint += `&organisation_id=${organisationId}`
      }
      let spaceData = await fetch(endpoint, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
        .then((response) => response.json())
        .catch((error) => {
          util.logToSentry(error)
          util.logAmplitudeEvent("Unknown Error Retrieving Synced Spaces")
        })
      if (organisationId) {
        document.getElementById("spaces-to-sync-section").classList.add("hide")
        // Clear results of a previous run
        let spacesToSync = document.getElementById("spaces-to-sync")
        while (spacesToSync.childNodes.length > 1) {
          spacesToSync.removeChild(spacesToSync.lastChild)
        }
      }
      spaceData.spaces_without_syncs.map((space) => {
        let divFlexSpace = document.createElement("div")
        divFlexSpace.classList.add("flex-space-sync")
        divFlexSpace.dataset.spaceId = space.id
        let divTextBlock = document.createElement("div")
        divTextBlock.innerText = space.name
        let button = document.createElement("a")
        button.classList.add("green-button-dashboard")
        button.innerText = "Sync calendar"
        button.href = "#"
        button.addEventListener("click", async (e) => {
          // Don't follow the link
          e.preventDefault()
          openSyncMethodModal(space.id, organisationId)
          util.logAmplitudeEvent("Click Sync Calendar", {
            "Space ID": space.id,
          })
        })

        divFlexSpace.appendChild(divTextBlock)
        divFlexSpace.appendChild(button)
        document.getElementById("spaces-to-sync").appendChild(divFlexSpace)
        document
          .getElementById("spaces-to-sync-section")
          .classList.remove("hide")
      })
      let syncedSpaces = document.getElementById("synced-spaces")
      if (organisationId) {
        syncedSpaces.replaceChildren()
        document.getElementById("synced-spaces-section").classList.add("hide")
      }
      let prevSpaceId = null
      spaceData.synced_spaces.map((sync) => {
        let divFlexSpace = document.createElement("div")
        divFlexSpace.classList.add("flex-synced-space")
        divFlexSpace.dataset.spaceId = sync.space_id
        if (sync.space_id !== prevSpaceId) {
          let divSpace = document.createElement("div")
          divSpace.classList.add("sync-space")
          divSpace.innerText = sync.space_name
          divFlexSpace.appendChild(divSpace)
          let anotherSyncLink = document.createElement("a")
          anotherSyncLink.classList.add("sync-link")
          anotherSyncLink.innerText = "Sync this space with another calendar"
          anotherSyncLink.href = "#"
          anotherSyncLink.addEventListener("click", async (e) => {
            // Don't follow the link
            e.preventDefault()
            openSyncMethodModal(sync.space_id, organisationId)
            util.logAmplitudeEvent("Click Additional Sync Modal", {
              "Space ID": sync.space_id,
            })
          })
          divFlexSpace.appendChild(anotherSyncLink)
          prevSpaceId = sync.space_id
        }
        let divCalendar = document.createElement("div")
        divCalendar.style.wordBreak = "break-word"
        let calendarSpan = document.createElement("span")
        calendarSpan.style.fontWeight = "500"
        calendarSpan.textContent = "Calendar: "
        divCalendar.appendChild(calendarSpan)
        let calendarName
        if (sync.is_ics_feed) {
          calendarName = "Synced to iCalendar URL"
          if (sync.ics_feed_url) {
            calendarName += " " + sync.ics_feed_url
          }
        } else {
          calendarName = sync.cronofy_calendar_name
          if (
            sync.profile_name &&
            sync.cronofy_calendar_name !== sync.profile_name
          ) {
            calendarName += " (" + sync.profile_name + ")"
          }
        }
        divCalendar.appendChild(document.createTextNode(calendarName))

        let divAddedBy = document.createElement("div")
        let addedBySpan = document.createElement("span")
        addedBySpan.style.fontWeight = "500"
        addedBySpan.textContent = "Added by: "
        divAddedBy.appendChild(addedBySpan)
        divAddedBy.appendChild(document.createTextNode(sync.app_user_email))

        let divSyncSettings = document.createElement("div")
        let syncSettingsSpan = document.createElement("span")
        syncSettingsSpan.style.fontWeight = "500"
        syncSettingsSpan.textContent = "Sync: "
        divSyncSettings.appendChild(syncSettingsSpan)
        let syncText
        if (sync.should_sync_bookings && sync.should_sync_events) {
          syncText =
            "Two-way (bookings sync to your calendar, calendar events sync as Sharesy blocks)"
        } else if (sync.should_sync_bookings) {
          syncText =
            "One-way (bookings sync to your calendar, but calendar events don't sync as Sharesy blocks)"
        } else if (sync.should_sync_events) {
          syncText =
            "One-way (calendar events sync as Sharesy blocks, but bookings don't sync to your calendar)"
        } else {
          syncText =
            "No sync (bookings don't sync to your calendar, calendar events don't sync as Sharesy blocks)"
        }
        divSyncSettings.appendChild(document.createTextNode(syncText))

        let disconnectLink = document.createElement("a")
        disconnectLink.classList.add("red")
        disconnectLink.innerText = "Disconnect"
        disconnectLink.href = "#"
        disconnectLink.addEventListener("click", async (e) => {
          document.getElementById("modal-container").style.display = "flex"
          document.getElementById("disconnect-sync-modal").style.display =
            "flex"
          util.logAmplitudeEvent("Open Disconnect Sync Modal")
          let confirmDisconnectButton =
            document.getElementById("confirm-disconnect")
          confirmDisconnectButton.dataset.calendarSyncId = sync.id
          confirmDisconnectButton.dataset.spaceId = sync.space_id
        })
        divFlexSpace.appendChild(divCalendar)
        divFlexSpace.appendChild(divAddedBy)
        divFlexSpace.appendChild(divSyncSettings)
        divFlexSpace.appendChild(disconnectLink)
        syncedSpaces.appendChild(divFlexSpace)
        document
          .getElementById("synced-spaces-section")
          .classList.remove("hide")
      })
    }

    function openSyncMethodModal(spaceId, organisationId) {
      let stateJson = {
        space_id: spaceId,
      }
      if (organisationId) {
        stateJson.organisation_id = organisationId
      }

      let clientId = "oZAud5vmi4PIexaOX51zY0K7YDoum7Fu"
      let redirectUri = "https%3A%2F%2Fwww.sharesy.com%2Fcalendar%2Dsync"
      if (util.isDev) {
        redirectUri = "https%3A%2F%2Fstaging.sharesy.com%2Fcalendar%2Dsync"
        clientId = "cML25gSonlLlzwn5GWLAo5R7G8t2gmnS"
      }
      // Once a calendar account has been connected, the Cronofy code is
      // returned in the 'code' query param.
      document.getElementById(
        "sync-calendar-button"
      ).href = `https://app-uk.cronofy.com/oauth/v2/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=read_write&avoid_linking=true&state=${encodeURIComponent(
        JSON.stringify(stateJson)
      )}`

      document.getElementById("sync-ical-button").dataset.spaceId = spaceId

      document.getElementById("sync-method-modal").style.display = "flex"
      document.getElementById("modal-container").style.display = "flex"
    }

    function postSyncCleanup() {
      // Remove the params so if user refreshes themselves they start from the beginning
      searchParams = util.getSearchParams()
      searchParams.delete("state")
      searchParams.delete("code")
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${searchParams}`
      )
      document.getElementById("choose-calendar-modal").style.display = "none"
      document.getElementById("sync-ical-modal").style.display = "none"
      document.getElementById("modal-container").style.display = "none"
      document.getElementById("choose-calendar-button").innerText = "Sync now"
    }

    function postSyncDisconnectCleanup() {
      document.getElementById("disconnect-sync-modal").style.display = "none"
      document.getElementById("modal-container").style.display = "none"
      document.getElementById("confirm-disconnect").innerText = "Disconnect"
    }

    /**
     * Disable the buttons and links for this space while Cronofy is processing
     * in the background
     */
    function disableSpaceLink(spaceId) {
      let spacesToSync = document.querySelectorAll(
        `[data-space-id="${spaceId}"].flex-synced-space, [data-space-id="${spaceId}"].flex-space-sync`
      )
      spacesToSync.forEach((element) => {
        element.querySelector("a").classList.add("disabled")
      })
    }

    function updateFutureBookingsSection() {
      const shouldSyncBookings =
        document.querySelector('input[name="bookings"]:checked')?.value === "yes"
      const futureBookingsSection = document.getElementById(
        "future-bookings-section"
      )
      const futureBookingsInputs = document.querySelectorAll(
        'input[name="future-bookings"]'
      )

      if (shouldSyncBookings) {
        futureBookingsSection.classList.remove("hide")
        futureBookingsInputs.forEach((input) => {
          input.disabled = false
          input.required = true
        })
      } else {
        futureBookingsSection.classList.add("hide")
        futureBookingsInputs.forEach((input) => {
          input.checked = false
          input.disabled = true
          input.required = false
        })
      }
    }

    function init() {
      initChecks()

      try {
        document
          .getElementById("sync-method-modal-close")
          .addEventListener("click", (e) => {
            document.getElementById("modal-container").style.display = "none"
            document.getElementById("sync-method-modal").style.display = "none"
            util.logAmplitudeEvent("Close Choose Sync Method Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("sync-ical-link")
          .addEventListener("click", (e) => {
            e.preventDefault()
            document.getElementById("sync-method-modal").style.display = "none"
            document.getElementById("sync-ical-modal").style.display = "flex"
            util.logAmplitudeEvent("Open Import iCalendar Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("sync-ical-modal-close")
          .addEventListener("click", (e) => {
            document.getElementById("modal-container").style.display = "none"
            document.getElementById("sync-ical-modal").style.display = "none"
            util.logAmplitudeEvent("Close Import iCalendar Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("sync-ical-button")
          .addEventListener("click", async (event) => {
            event.preventDefault()
            let iCalForm = document.getElementById("ical-sync-form")
            if (!iCalForm.checkValidity()) {
              iCalForm.reportValidity()
              return
            }
            let buttonText = event.target.value
            event.target.value = "Please wait..."
            event.target.disabled = true
            let token = await utillogin.getClerkToken()
            let requestCompleted = false
            let timedOut = false
            setTimeout(() => {
              if (!requestCompleted) {
                timedOut = true
                Toastify({
                  text: "Your sync is still running (it may take up to 60 seconds to sync all events). We will notify you when it completes.",
                  duration: 4000,
                  close: true,
                  gravity: "top",
                  position: "center",
                  stopOnFocus: true,
                  style: {
                    background: "#fc9600",
                  },
                }).showToast()
                disableSpaceLink(event.target.dataset.spaceId)
                postSyncCleanup()
                util.logAmplitudeEvent("iCalendar Sync Still Running")
              }
            }, 5000)
            let cronofySyncICal = await fetch(
              `${util.API_GATEWAY}/cronofy-sync-ics-feed`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  token: token,
                  space_id: event.target.dataset.spaceId,
                  feed_url: document.getElementById("ical-url").value.trim(),
                }),
              }
            )
              .then((response) => response.json())
              .catch((error) => {
                util.logToSentry(error)
                util.logAmplitudeEvent("Unknown Error Syncing iCalendar")
              })
            requestCompleted = true
            postSyncCleanup()
            if (cronofySyncICal?.success) {
              util.logAmplitudeEvent("iCalendar Sync Successful")
              if (cronofySyncICal.num_events_synced === 0) {
                await Swal.fire({
                  icon: "success",
                  text: "Your iCalendar sync has completed but no events were found. If this isn't expected you can check our syncing help article - we may have advice for syncing the booking software you use. Otherwise you can either contact your booking software technical support or Sharesy at venuesupport@sharesy.com.",
                  confirmButtonText: "Refresh the list of synced spaces",
                  confirmButtonColor: "#1aa979",
                  customClass: {
                    popup: "swal-custom-popup",
                    title: "swal-custom-title",
                    confirmButton: "swal-custom-button",
                  },
                  allowOutsideClick: false,
                })
                window.location.reload()
              } else {
                let text = `Your iCalendar sync is complete - ${cronofySyncICal.num_events_synced}`
                if (cronofySyncICal.num_events_synced == 1) {
                  text += " event was synced."
                } else {
                  text += " events were synced."
                }
                if (cronofySyncICal.warning) {
                  text += " " + cronofySyncICal.warning
                }
                await Swal.fire({
                  icon: cronofySyncICal.warning ? "warning" : "success",
                  text: text,
                  confirmButtonText: "Refresh the list of synced spaces",
                  confirmButtonColor: cronofySyncICal.warning
                    ? "orange"
                    : "#1aa979",
                  customClass: {
                    popup: "swal-custom-popup",
                    title: "swal-custom-title",
                    confirmButton: "swal-custom-button",
                  },
                  allowOutsideClick: false,
                })
                window.location.reload()
              }
            } else {
              let message =
                "There was a problem syncing your iCalendar feed. Please try again - if it fails again please contact your booking software technical support or Sharesy at venuesupport@sharesy.com."
              if (cronofySyncICal?.message) {
                message = cronofySyncICal.message
              }
              await Swal.fire({
                icon: "error",
                text: message,
                confirmButtonText: "OK",
                confirmButtonColor: "#d31818",
                customClass: {
                  popup: "swal-custom-popup",
                  title: "swal-custom-title",
                  confirmButton: "swal-custom-button",
                },
                allowOutsideClick: false,
              })
              util.logAmplitudeEvent("iCalendar Sync Failed")
            }
            document.getElementById("ical-url").value = ""
            event.target.disabled = false
            event.target.value = buttonText
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("choose-calendar-modal-close")
          .addEventListener("click", (e) => {
            searchParams.delete("state")
            searchParams.delete("code")
            window.history.replaceState(
              {},
              "",
              `${window.location.pathname}?${searchParams}`
            )
            document.getElementById("modal-container").style.display = "none"
            document.getElementById("choose-calendar-modal").style.display =
              "none"
            util.logAmplitudeEvent("Close Choose Calendar Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("choose-calendar-button")
          .addEventListener("click", async (event) => {
            event.preventDefault()
            let shouldSyncBookings = null
            if (document.querySelector('input[name="bookings"]:checked')) {
              shouldSyncBookings =
                document.querySelector('input[name="bookings"]:checked')
                  .value === "yes"
            }
            updateFutureBookingsSection()
            let futureBookingsOnly = true
            if (
              document.querySelector('input[name="future-bookings"]:checked')
            ) {
              futureBookingsOnly =
                document.querySelector('input[name="future-bookings"]:checked')
                  .value === "future"
            }
            let shouldSyncEvents = null
            if (document.querySelector('input[name="events"]:checked')) {
              shouldSyncEvents =
                document.querySelector('input[name="events"]:checked').value ===
                "yes"
            }
            if (shouldSyncBookings === false && shouldSyncEvents === false) {
              document
                .getElementById("events-yes")
                .setCustomValidity(
                  "You need to answer Yes to at least one of these questions."
                )
            } else {
              document.getElementById("events-yes").setCustomValidity("")
            }
            let syncForm = document.getElementById("sync-form")
            if (syncForm.checkValidity()) {
              const buttonText = event.target.value
              event.target.value = "Please wait..."
              event.target.disabled = true
              let chosenCalendar = document.querySelector(
                'input[name="CalendarSyncOptions"]:checked'
              ).value
              const hideEventTitles = document.getElementById(
                "hide-event-titles-checkbox"
              ).checked
              let stateJson = JSON.parse(searchParams.get("state"))
              if (stateJson.organisation_id) {
                util.updateUrlParam(
                  "organisation",
                  stateJson.organisation_id,
                  false,
                  false
                )
                setOrganisation(stateJson.organisation_id)
              }
              let token = await utillogin.getClerkToken()
              let cronofyAccountId = calendarSyncData.cronofy_account_id
              let requestCompleted = false
              let timedOut = false
              setTimeout(() => {
                if (!requestCompleted) {
                  timedOut = true
                  Toastify({
                    text: "Your sync is still running (it may take up to 60 seconds to sync all events). We will notify you when it completes.",
                    duration: 4000,
                    close: true,
                    gravity: "top",
                    position: "center",
                    stopOnFocus: true,
                    style: {
                      background: "#fc9600",
                    },
                  }).showToast()
                  disableSpaceLink(stateJson.space_id)
                  postSyncCleanup()
                  util.logAmplitudeEvent("Calendar Sync Still Running")
                }
              }, 5000)

              let cronofySetCalendar
              const startTime = Date.now()
              try {
                const response = await fetch(
                  `${util.API_GATEWAY}/cronofy-set-calendar-token`,
                  {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      token: token,
                      space_id: stateJson.space_id,
                      calendar_id: chosenCalendar,
                      cronofy_account_id: cronofyAccountId,
                      should_sync_events: shouldSyncEvents,
                      should_sync_bookings: shouldSyncBookings,
                      future_bookings_only: futureBookingsOnly,
                      hide_event_titles: hideEventTitles,
                    }),
                  }
                )
                if (response.status === 504) {
                  cronofySetCalendar = { success: false, is_timeout: true }
                } else {
                  cronofySetCalendar = await response.json()
                }
              } catch (error) {
                // When Google Cloud API Gateway times out after 60 seconds it returns a
                // 504 Gateway Timeout response. However, this 504 response doesn't
                // include CORS headers, so the browser blocks it and throws a "Failed
                // to fetch" TypeError instead of letting us read response.status === 504.
                // So the check above for 504 errors isn't reached.
                //
                // We use timing-based detection (55+ seconds) to distinguish gateway
                // timeouts from other "Failed to fetch" errors (network issues, DNS
                // failures, etc).
                const durationSeconds = (Date.now() - startTime) / 1000
                if (
                  error.message &&
                  error.message.includes("Failed to fetch") &&
                  durationSeconds > 55
                ) {
                  util.logAmplitudeEvent("Calendar Sync Timeout")
                  cronofySetCalendar = { success: false, is_timeout: true }
                } else {
                  util.logToSentry(error)
                  util.logAmplitudeEvent("Unknown Error Syncing Calendar")
                  cronofySetCalendar = { success: false }
                }
              }

              requestCompleted = true
              postSyncCleanup()

              if (cronofySetCalendar?.success) {
                util.logAmplitudeEvent("Calendar Sync Successful")
                if (!cronofySetCalendar.events_synced) {
                  await Swal.fire({
                    icon: "success",
                    text: "Your calendar sync was successful but it may take another 30 seconds to sync all events.",
                    confirmButtonText: "Refresh the list of synced spaces",
                    confirmButtonColor: "#1aa979",
                    customClass: {
                      popup: "swal-custom-popup",
                      title: "swal-custom-title",
                      confirmButton: "swal-custom-button",
                    },
                    allowOutsideClick: false,
                  })
                } else {
                  if (timedOut) {
                    await Swal.fire({
                      icon: "success",
                      text: "Your calendar sync was successful.",
                      confirmButtonText: "Refresh the list of synced spaces",
                      confirmButtonColor: "#1aa979",
                      customClass: {
                        popup: "swal-custom-popup",
                        title: "swal-custom-title",
                        confirmButton: "swal-custom-button",
                      },
                      allowOutsideClick: false,
                    })
                  }
                  // If it didn't time out, just reload without a popup message
                }
              } else {
                let message
                if (cronofySetCalendar?.is_timeout) {
                  message =
                    "Your calendar sync is still running in the background. It may take another few minutes to complete."
                  util.logAmplitudeEvent("Calendar Sync Timeout")
                  await Swal.fire({
                    icon: "warning",
                    text: message,
                    confirmButtonText: "Refresh",
                    confirmButtonColor: "#1aa979",
                    customClass: {
                      popup: "swal-custom-popup",
                      title: "swal-custom-title",
                      confirmButton: "swal-custom-button",
                    },
                    allowOutsideClick: false,
                  })
                } else {
                  message =
                    "There was a problem syncing your calendar. Click to refresh and try again. If it fails again please contact venuesupport@sharesy.com."
                  if (cronofySetCalendar?.message) {
                    message = cronofySetCalendar.message
                  }
                  util.logAmplitudeEvent("Calendar Sync Failed")
                  await Swal.fire({
                    icon: "error",
                    text: message,
                    confirmButtonText: "Refresh",
                    confirmButtonColor: "#d31818",
                    customClass: {
                      popup: "swal-custom-popup",
                      title: "swal-custom-title",
                      confirmButton: "swal-custom-button",
                    },
                    allowOutsideClick: false,
                  })
                }
              }
              // In all cases reload afterwards
              window.location.reload()
            } else {
              syncForm.reportValidity()
              util.logAmplitudeEvent("Select Calendar Form Not Valid")
            }
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        // If the user selects "yes" to syncing bookings, ask if they want to
        // sync future bookings only
        document.querySelectorAll('input[name="bookings"]').forEach((elem) => {
          elem.addEventListener("change", updateFutureBookingsSection)
        })
        updateFutureBookingsSection()
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        // If the user selects "yes" to syncing events, unhide the hide event titles checkbox
        document.querySelectorAll('input[name="events"]').forEach((elem) => {
          elem.addEventListener("change", function (event) {
            if (event.target.value === "yes") {
              document.getElementById("hide-titles").classList.remove("hide")
            } else {
              document.getElementById("hide-titles").classList.add("hide")
            }
          })
        })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("confirm-disconnect")
          .addEventListener("click", async (event) => {
            event.target.innerText = "Please wait..."
            let calendarSyncId = event.target.dataset.calendarSyncId
            let token = await utillogin.getClerkToken()
            let requestCompleted = false
            let timedOut = false
            setTimeout(() => {
              if (!requestCompleted) {
                timedOut = true
                Toastify({
                  text: "The calendar disconnect is still running (it may take up to 30 seconds). We will notify you when it completes.",
                  duration: 4000,
                  close: true,
                  gravity: "top",
                  position: "center",
                  stopOnFocus: true,
                  style: {
                    background: "#fc9600",
                  },
                }).showToast()
                disableSpaceLink(event.target.dataset.spaceId)
                event.target.dataset.spaceId
                postSyncDisconnectCleanup()
                util.logAmplitudeEvent("Calendar Sync Disconnect Still Running")
              }
            }, 5000)
            let cronofyRemoveSync = await fetch(
              `${util.API_GATEWAY}/cronofy-remove-sync-token`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                  token: token,
                  calendar_sync_id: parseInt(calendarSyncId),
                }),
              }
            )
              .then((response) => response.json())
              .catch((error) => {
                util.logToSentry(error)
                util.logAmplitudeEvent("Unknown Error Disconnecting Sync")
              })
            requestCompleted = true
            postSyncDisconnectCleanup()
            if (cronofyRemoveSync?.success) {
              util.logAmplitudeEvent("Disconnect Sync Successful")
              if (!timedOut) {
                window.location.reload()
              } else {
                await Swal.fire({
                  icon: "success",
                  text: "The calendar has been disconnected.",
                  confirmButtonText: "Refresh the list of synced spaces",
                  confirmButtonColor: "#1aa979",
                  customClass: {
                    popup: "swal-custom-popup",
                    title: "swal-custom-title",
                    confirmButton: "swal-custom-button",
                  },
                  allowOutsideClick: false,
                })
                window.location.reload()
              }
            } else {
              await Swal.fire({
                icon: "error",
                text: "There was a problem disconnecting your calendar. Click to refresh and try again. If it fails again please contact venuesupport@sharesy.com.",
                confirmButtonText: "Refresh",
                confirmButtonColor: "#d31818",
                customClass: {
                  popup: "swal-custom-popup",
                  title: "swal-custom-title",
                  confirmButton: "swal-custom-button",
                },
                allowOutsideClick: false,
              })
              window.location.reload()
              util.logAmplitudeEvent("Disconnect Sync Failed")
            }
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("cancel-disconnect")
          .addEventListener("click", async (e) => {
            document.getElementById("modal-container").style.display = "none"
            document.getElementById("disconnect-sync-modal").style.display =
              "none"
            util.logAmplitudeEvent("Cancel Disconnect Sync Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }

      try {
        document
          .getElementById("disconnect-sync-modal-close")
          .addEventListener("click", (e) => {
            document.getElementById("modal-container").style.display = "none"
            document.getElementById("disconnect-sync-modal").style.display =
              "none"
            util.logAmplitudeEvent("Close Disconnect Sync Modal")
          })
      } catch (err) {
        util.logToSentry(err)
      }
    }

    return {
      init: init,
    }
  })()
}
